import { useMemo } from "react";
import { PORTRAIT_IMAGES } from "../Portrait/portraitImages";
import { EMPTY_LIST } from "constants/defaults";

export const usePortraitImages = ({
  prefix = EMPTY_LIST,
  suffix = EMPTY_LIST,
} = {}) => {
  return useMemo(() => {
    return [...prefix, ...PORTRAIT_IMAGES, ...suffix];
  }, [prefix, suffix]);
};
